export const BUILD_TYPE = 'current';
export const VERSION_NUMBER = '2.3.0';
export const BUILD_NUMBER = '2026.9.30.1';
export const DESKTOP_AGENT_MINIMUM_REQUIRED_VERSION = '0.5.0';
